export default __webpack_public_path__ + "static/media/header.74c644c9.jpg";